/* Product pages: tapping the Judge.me star badge scrolls to the reviews.
   Moved out of layout/theme.liquid (still product pages only) so browsers cache it. */
(function () {
  function target() {
    return document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('.jdgm-widget.jdgm-review-widget');
  }

  /* v56: how much of the top of the screen is covered once we get there:
     - the header bar. Measured on the bar itself: once the header sticks, the <header> box around it
       is ~0px tall, which used to land the reviews heading underneath the header.
     - the category bar pinned under the header on product pages (sections/linklist.liquid shares its
       height as --rynor-pinbar-h; 0 when it isn't there). */
  function coveredTop() {
    var off = 0;
    var bars = document.querySelectorAll('header.section-header .section-header__main-bar, header.section-header .section-header__mobile');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].getClientRects().length) off = Math.max(off, bars[i].offsetHeight);
    }
    if (!off) {
      var header = document.querySelector('#shopify-section-header,header,.header');
      off = header ? header.getBoundingClientRect().height : 0;
    }
    var pinbar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rynor-pinbar-h')) || 0;
    return Math.ceil(off + pinbar);
  }

  function scrollToReviews() {
    var w = target();
    if (!w) return false;

    var d = w.closest && w.closest('details');
    if (d && !d.open) d.open = true;

    var off = coveredTop();
    var y = w.getBoundingClientRect().top + window.pageYOffset - off - 12;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.jdgm-prev-badge,.jdgm-prev-badge__stars,.jdgm-prev-badge__text,.jdgm-star');
    if (!hit) return;

    if (scrollToReviews()) {
      e.preventDefault();
      return;
    }

    var obs = new MutationObserver(function () {
      if (scrollToReviews()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 4000);
  }, true);

  if (location.hash && location.hash.indexOf('judgeme_product_reviews') > -1) {
    window.addEventListener('load', function () {
      setTimeout(scrollToReviews, 200);
    });
  }
})();
